/** Per-office attendance configuration */
export interface OfficeAttendanceSettings {
  officeRadius: number; // meters (e.g. 200)
  shiftStartTime: string; // "HH:mm" e.g. "09:00"
  shiftEndTime: string; // "HH:mm" e.g. "18:00"
  gracePeriodMinutes: number; // minutes after shift start before marking late
  lateThresholdMinutes: number; // extra threshold after grace period
}

/** Per-office holiday configuration */
export interface OfficeHolidayConfig {
  enabled: boolean;
  weeklyOff: string; // e.g. "sunday"
  secondSaturdayOff: boolean;
  fourthSaturdayOff: boolean;
  holidayDates: string[]; // list of "YYYY-MM-DD" specific holidays
}

export const DEFAULT_OFFICE_ATTENDANCE: OfficeAttendanceSettings = {
  officeRadius: 200,
  shiftStartTime: '09:00',
  shiftEndTime: '18:00',
  gracePeriodMinutes: 0,
  lateThresholdMinutes: 0,
};

export const DEFAULT_OFFICE_HOLIDAYS: OfficeHolidayConfig = {
  enabled: false,
  weeklyOff: 'sunday',
  secondSaturdayOff: false,
  fourthSaturdayOff: false,
  holidayDates: [],
};

export interface Office {
  id: string;
  name: string;
  city: string;
  address: string;
  geoLocation: {
    latitude: number;
    longitude: number;
  };
  isActive: boolean;
  attendanceSettings?: OfficeAttendanceSettings;
  holidayConfig?: OfficeHolidayConfig;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
}

export interface OfficeFormData {
  name: string;
  city: string;
  address: string;
  latitude: number;
  longitude: number;
  attendanceSettings: OfficeAttendanceSettings;
  holidayConfig: OfficeHolidayConfig;
}

export const DUMMY_OFFICES: Omit<Office, 'id' | 'createdAt' | 'updatedAt' | 'createdBy'>[] = [
  {
    name: "Noida Office",
    city: "Noida",
    address: "Sector 62, Noida, Uttar Pradesh 201301, India",
    geoLocation: {
      latitude: 28.6139,
      longitude: 77.2090,
    },
    isActive: true,
  },
  {
    name: "Mumbai Office",
    city: "Mumbai",
    address: "Andheri East, Mumbai, Maharashtra 400069, India",
    geoLocation: {
      latitude: 19.0760,
      longitude: 72.8777,
    },
    isActive: true,
  },
  {
    name: "Bangalore Office",
    city: "Bangalore",
    address: "Koramangala, Bangalore, Karnataka 560034, India",
    geoLocation: {
      latitude: 12.9352,
      longitude: 77.6245,
    },
    isActive: true,
  },
];
